var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('BtHeader',{attrs:{"background-style":"light"},scopedSlots:_vm._u([{key:"branding-logo",fn:function(){return [_c('BrandingLogo')]},proxy:true}])}),_c('BtMainContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }